import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { MapWaterSystemsMetricsInitialState } from '../mapWaterSystemMetrics.slice'
import { IMapWaterSystemsMetrics, RequestConfig } from '../../../../types';

export const fetchMapWaterSystemMetricsAsync = createAsyncThunk(
  'metrics/fetchMapMetrics',
  async ({ options }: { options?: RequestConfig },
    { rejectWithValue },) => {
    try {
      const response = await EpaApi.fetchMapWaterSystemsMetrics(options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchMapWaterSystemMetricsAsyncBuilder = (
  builder: ActionReducerMapBuilder<MapWaterSystemsMetricsInitialState>
) => {
  builder.addCase(fetchMapWaterSystemMetricsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchMapWaterSystemMetricsAsync.fulfilled,
    (state, action: PayloadAction<IMapWaterSystemsMetrics>) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    }
  );

  builder.addCase(
    fetchMapWaterSystemMetricsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};